import React, { useState } from 'react';
import { Box, CircularProgress, Dialog, DialogActions, DialogTitle, Tooltip } from '@material-ui/core';
import { TextInputSyndikos } from 'components/common/Formulario';
import InputFile from 'components/common/InputFile';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { Field } from 'react-final-form';
import { Form } from 'react-final-form';
import { CloseButton, ConfirmButton } from 'components/common/commonComponentsTSX';
import { CustomDataProvider } from '../types';
import InfoIcon from '@material-ui/icons/Info';

interface AddCommentModalProps {
	closeAddCommentModal: () => void;
	ocorrenciaId: number;
}

interface FormValues {
	mensagem: string;
	ocorrencia: number;
	tipo_acao: string;
	write_only_anexo: string;
	preventDefault: () => void;
}

const AddCommentModal: React.FC<AddCommentModalProps> = ({ closeAddCommentModal, ocorrenciaId }) => {
	const notify = useNotify();
	const refresh = useRefresh();

	const [finalizando, setFinalizando] = useState(false);

	const dataProvider: CustomDataProvider = useDataProvider();

	const handleSubmit = ({ mensagem, write_only_anexo }: FormValues) => {
		setFinalizando(true);
		dataProvider
			.simplePost('acao_ocorrencias', {
				data: {
					mensagem: mensagem,
					ocorrencia: ocorrenciaId,
					tipo_acao: 'C',
					write_only_anexo: write_only_anexo,
				},
			})
			.then(() => {
				notify('Comentário enviado com sucesso');
				closeAddCommentModal();
				refresh();
				setFinalizando(false);
			})
			.catch((e: any) => {
				if ([401, 403].includes(e?.response?.status)) return Promise.reject(e);
				notify('Ocorreu um erro ao enviar o comentário');
				setFinalizando(false);
			});
	};

	return (
		<Form
			onSubmit={(e) => {
				e.preventDefault();
			}}
			render={({ values }: { values: FormValues }) => (
				<Dialog open={true} fullWidth>
					<Box display={'flex'}>
						<DialogTitle style={{ paddingRight: 10 }}>Novo Comentário</DialogTitle>
						<Tooltip
							title={
								<h3>
									Este comentário será direcionado ao responsável que fez o registro da ocorrência.
									Para verificar as mensagens clique na aba &quot;Histórico de Ações&quot;
								</h3>
							}
							placement='right'
							arrow
						>
							<InfoIcon style={{ marginTop: '2vh' }} />
						</Tooltip>
					</Box>
					<Box flex={1} mr='1em' marginBottom={'2vh'}>
						<Box display='flex' flex={1} ml={1} mb={1.5} marginTop={2}>
							<Field name={'mensagem'}>
								{({ input, meta }) => (
									<TextInputSyndikos
										label='Mensagem'
										source='mensagem'
										variant='outlined'
										multiline
										fullWidth
										rows={8}
										validate={(value: string) => {
											if (!value) {
												return 'Este campo é obrigatório';
											} else if (value.length > 500) {
												return `Máximo excedido: ${value.length}/500`;
											} else {
												return '';
											}
										}}
										helperText={meta?.error ? meta?.error : `${(input?.value || '').length}/500`}
										defaultValue=''
									/>
								)}
							</Field>
						</Box>
						<Box display='flex' flex={0.5} ml={1}>
							<Field name='write_only_anexo' id='write_only_anexo'>
								{({ input }) => (
									<InputFile
										source='write_only_anexo'
										label='Arquivo em anexo'
										variant='outlined'
										onCallBack={(e: any, dataUrl: string) => {
											input.onChange(dataUrl);
										}}
										fileDataUrl={undefined}
									/>
								)}
							</Field>
						</Box>
					</Box>
					<DialogActions>
						<CloseButton onClick={closeAddCommentModal} size='small'>
							Voltar
						</CloseButton>
						<ConfirmButton
							onClick={() => handleSubmit(values)}
							size='small'
							disabled={!values.mensagem || values.mensagem.length > 500}
						>
							{(finalizando && <CircularProgress size={20} />) || 'Confirmar'}
						</ConfirmButton>
					</DialogActions>
				</Dialog>
			)}
		/>
	);
};

export default AddCommentModal;
